import type { ReactNode } from "react";
import { useDocument } from "@rosette/web_utils/src/ssrHelper.js";
import { createPortal } from "react-dom";


interface BodyPortalProps {
    children?: ReactNode;
}


export function BodyPortal({ children }: BodyPortalProps) {
    const document = useDocument();
    return (
        <>
            {document && createPortal(
                children, document.body,
            )}
        </>
    );
}
